import {z} from 'zod';

import {isNil} from 'ramda';

import {ScopeValues} from '@dms/api/shared';

export const evaluateServiceOrderType = (scopes: string[], evaluatorParams: ScopeValues) => {
  const {serviceOrderType} = validateServiceOrderEvaluatorParams(evaluatorParams);

  if (serviceOrderType === 'SKIP') {
    return true;
  }

  if (isNil(serviceOrderType)) {
    return false;
  }

  return scopes.includes(serviceOrderType);
};

// export only for testing purposes
export const validateServiceOrderEvaluatorParams = (evaluatorParams: ScopeValues | null) =>
  serviceOrderParamsSchema.parse(evaluatorParams);

const serviceOrderParamsSchema = z.object({
  serviceOrderType: z.string().nullable(),
});
